// Libraries
import React from 'react';
import { useLazyQuery } from 'react-apollo';
import { get, join, capitalize } from 'lodash';
import { useHistory } from "react-router-dom";
import { loader } from 'graphql.macro';

// Config
import {
  ERROR_CONNECTION,
  MESSAGES_MAP
} from 'config';

// Types
import { SESSION_TYPE } from 'services/session';

// Data
import { COLUMNS, GET_ACTIONS_CELL } from './data';

// GraphQL
const familyCasesQuery = loader('src/graphql/queries/familyCases.gql');

export type LIST_PROPS_TYPE = {
  session?: SESSION_TYPE,
  url: string
};

export const useList = ({
  session,
  url
}: LIST_PROPS_TYPE) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);

  const columns = React.useMemo(
    () => COLUMNS,
    []
  );

  const [error, setError] = React.useState<string | boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const [
    handleFamilyCasesQuery,
    {
      loading: familyCasesQueryLoading,
      data: familyCasesQueryData,
      error: familyCasesQueryError
    }] = useLazyQuery(familyCasesQuery, {
    fetchPolicy: 'no-cache'
  });

  const token = get(session, 'token');

  React.useEffect(() => {
    setLoading(!!familyCasesQueryLoading);
  }, [familyCasesQueryLoading]);

  React.useEffect((): any => {
    !!token && handleFamilyCasesQuery();
  },[token]);

  React.useEffect((): any => {
    if (!familyCasesQueryData || familyCasesQueryLoading) {
      return;
    }
    const isError = get(familyCasesQueryData, 'familyCases.__typename') === 'Error';
    const message = get(familyCasesQueryData, 'familyCases.message');
    const normalizedData = get(familyCasesQueryData, 'familyCases.data', []).map((familyCases: object) => ({
      ...familyCases,
      applied: `${get(familyCases, 'applied.surname', '')} ${capitalize(get(familyCases, 'applied.name', '').substr(0,1))}. ${capitalize(get(familyCases, 'applied.patronymic', '').substr(0,1))}.`,
      creator: `${get(familyCases, 'creator.surname', '')} ${capitalize(get(familyCases, 'creator.name', '').substr(0,1))}. ${capitalize(get(familyCases, 'creator.patronymic', '').substr(0,1))}.`,
      programm: get(familyCases, 'programm.title', ''),
      actions: GET_ACTIONS_CELL({
        ...familyCases,
        onEdit: () => history.push(`${url}/${get(familyCases, 'id')}`),
      })
    }));

    const dataError = isError && get(MESSAGES_MAP, `${message}`, message);
    const currentErrors = [
      ...(familyCasesQueryError ? [ERROR_CONNECTION] : []),
      ...(dataError ? [dataError] : []),
    ];
    currentErrors.length > 0 ? setError(join(currentErrors, '\n')) : setData(normalizedData);

  }, [familyCasesQueryData]);

  return {
    loading,
    error,
    data,
    columns,
  };
};

export default useList;
